/*****************************************
 *Default props collector
 *****************************************/
class DefaultPropsCollector {
    getFonts() {
        return {}
    }

    getThemes() {
        return {}
    }

    getCssData() {
        return {}
    }

    getFontUrlsCss() {
        return {}
    }

    /**
     * Uses as a hook for the user to transform a pasted href link (can be used to transform the link to a unique id)
     * @param {string} link - the link that was found
     * @returns {string} - the transform link
     */
    convertExternalLinkToLinkRef(link) {
        return link
    }

    /**
     * Uses as a hook for the user to transform an internal pasted link (can be used to clone a unique id for a transformed link)
     * @param {string} linkRef - a linkRef
     * @returns {string} - the transformed linkRef
     */
    convertLinkRefToLinkRef(linkRef) {
        return linkRef
    }

    /**
     * Uses as a hook for the user to transform an internal linkRef to the actual link, called when mainController.getData() is called
     * @param {string} linkRef - a linkRef
     * @returns {object} - the attributes and values that should be on the resulted a tag
     */
    convertLinkRefToAttributes(linkRef) {
        return {href: linkRef}
    }

    /**
     * Uses as a hook for the user to transform attributes to a unique id, called when mainController.setData() is called
     * @param {object} attributesObj - an object representing the attributes found on the a tag
     * @returns {string} - a string representing this object, to be later queried using convertLinkRefToAttributes
     */
    convertAttributesToLinkRef(attributesObj) {
        return attributesObj.href
    }
}


module.exports = DefaultPropsCollector



// WEBPACK FOOTER //
// ./src/propsCollector/defaultPropsCollectors.js